module.exports = __webpack_public_path__ + "static/media/bloodstained2.aec79e7f.png";